import React from 'react';
import Radium from 'radium';

import {A} from 'views/AppElements';
import AppUtil from 'AppUtil';

import Loader from 'views/Loader';
import PriceLabel from 'views/product/PriceLabel';

import {Img} from 'views/AppElements';
import UserAvatar from 'views/user/UserAvatar';

import ProductTags from 'views/product/ProductTags';
import AppConstants from 'AppConstants';

const ARTWORK_TYPES = AppConstants.ARTWORK_TYPES;
const PRODUCT_TYPES = AppConstants.PRODUCT_TYPES;


const styles = {
	containerStyle: {flexWrap: 'nowrap'},
	imgContainer: {position: 'relative', boxSizing: 'border-box', '@media (max-width: 600px)': {width: '-webkit-fill-available'}},
	previewImgContainer: {position: 'relative', boxSizing: 'border-box', flexWrap: 'nowrap'},

	productInfoContainer: {position: 'absolute', bottom: '0', background: 'white', 
																width: 'inherit', borderTop: '1px solid #eee',
																fontSize: '100%',
																'@media (max-width: 884px)': {fontSize: '95%'},
																'@media (max-width: 600px)': {fontSize: '110%', minWidth: '285px'}
																},

	productTitle: {color: 'black', paddingLeft: '10px', paddingTop: '5px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', width: '90%'},

	creatorContainer: {margin: '5px 0', alignItems:'center', paddingLeft: '10px', '@media (max-width: 884px)': {marginBottom: '5px'}},

	productTags: {'@media (min-width: 500px)': {display: 'none'}, margin: '-5px 5px 0px 5px'}
};

const ProductDesignLoader = Radium((props) => {
	let customStyles = [styles.containerStyle, {border : '1px solid rgb(238, 238, 238)', 
				boxSizing: 'border-box', '@media (max-width: 600px)': {width: '100%'}}];

	if(props.style) 
		customStyles.push(props.style);

	const viewMode = props.productViewMode || 'productOnly';
	const showPreview = viewMode === 'designOnly' || viewMode === 'both';
	const showProduct = viewMode === 'productOnly' || viewMode === 'both';

	const imageSizeClass = props.imageSizeClass;

	const previewImgContainer = [styles.previewImgContainer];

	if(viewMode === 'both')
		previewImgContainer.push({'@media (max-width: 500px)': {display: 'none'}});

	return <div className='productDesignThumbnail flexRow' style={customStyles}>
			
			{
				showPreview &&
				<div className={imageSizeClass} style={previewImgContainer}>

					<Img />	
				</div>
			}
			
			{
				showProduct &&
				<div className={'flexColumn '+imageSizeClass} style={[styles.imgContainer]}>
					<Img />

					<div className='flexColumn productInfo' style={[styles.productInfoContainer, {height: '20%'}]}>
						
						<Loader style={{width: '30%', height: '30%', marginTop: '5px', paddingLeft: '10px'}}/>

						<div className='flexRow' style={{marginBottom: '5px', 
															height: '30%', marginTop: 'auto',
																'@media (max-width: 884px)': {marginBottom: '5px'}}}>

							<Loader style={{width: '50%', paddingLeft: '10px'}}/>

							<Loader style={{width: '30%', paddingRight: '10px', marginLeft: 'auto'}} />
						</div>
					</div>
				</div>
			}
			
	</div>
});

class ProductDesignThumbnail extends React.Component {

	constructor(props) {
		super(props);
		this.state = {imageLoaded: false};
	}

	onImageLoad() {
		this.setState({imageLoaded: true});
	}

	render() {
		const imageSizeClass = this.props.imageSizeClass || 'largeImg';
		const product = this.props.product;

		if(product === null)
			return <ProductDesignLoader {...this.props} imageSizeClass={imageSizeClass} />;

		const detailUrl = product? AppUtil.getProductURL(product): null;

		const designerUrl = (product && product.creator)? AppUtil.getDesignerURL(product.creator): "#";
		const createrName = (product && product.creator)? AppUtil.getCreaterName(product.creator): null;
		const profilePic = <A href={designerUrl}><UserAvatar user={(product && product.creator)? product.creator: null}/></A>;
		const productType = product? PRODUCT_TYPES[product.productType].label: null;

		const productState = product.productState;
		
		let mainContainerClass = 'productDesignThumbnail flexRow '+productState.toLowerCase();
		if(product.artworkType === ARTWORK_TYPES['PHOTOGRAPH'].val)
			mainContainerClass += " photographDesignThumbnail";

		let containerStyles = [styles.containerStyle];

		if(this.props.style) 
			containerStyles.push(this.props.style);

		const mainWrapperStyle = this.state.imageLoaded === false? {'@media (max-width: 600px)': {width: '100%', height: '100%'}}: {marginRight: '15px'};

		const viewMode = this.props.productViewMode || 'productOnly';

		const showPreview = viewMode === 'designOnly' || viewMode === 'both';

		let previewImage = "";
		if(showPreview) {
			styles.imgContainer.borderLeft = '1px solid #e1e1e1';
			styles.imgContainer.borderRight = '1px solid #e1e1e1';
			
			if(product.previewImage){
				previewImage = <Img src={product.previewImage} alt={product.title+" "+productType} className={imageSizeClass} />;
			} else {
				if(viewMode === 'designOnly' || product.productImages.length > 1)
					previewImage = <Img src={product.productImages[product.productImages.length - 1]} alt={product.title+" "+productType} className={imageSizeClass} />;
				else {
					previewImage = <div className="previewImageAvatar"><UserAvatar user={product.creator} /></div>;
				}
			};
		}

		const previewImgContainer = [styles.previewImgContainer];

		if(viewMode === 'both')
			previewImgContainer.push({'@media (max-width: 500px)': {display: 'none'}});

		const showProduct = viewMode === 'productOnly' || viewMode === 'both';
		const productTags = (this.props.viewProductTags && product.productTags)? <ProductTags productTags={product.productTags} />: null;

		const urlQueryParams = this.props.hrefParams? Object.keys(this.props.hrefParams).map(k => k+"="+this.props.hrefParams[k]).join("&"): null;
		const productUrl = detailUrl + (urlQueryParams? "?"+urlQueryParams : "");
		return <div style={mainWrapperStyle}>
					<div className={mainContainerClass} style={containerStyles}>
						
						{showPreview && 
							<div style={previewImgContainer} className="flexColumn">
								<div className={imageSizeClass}>
									<A href={detailUrl}>
										{previewImage}
									</A>
								</div>
								
								{
									viewMode === "designOnly" && product.creator &&
									<div className="flexColumn" style={{paddingBottom: '5px', background: 'white', 
																		borderTop: '1px solid #e1e1e1', boxSizing: 'border-box', flexWrap: 'nowrap'}}>
										<div style={{textOverflow: 'ellipsis', overflow: 'hidden', 
													'@media (min-width: 500px)': {whiteSpace: 'nowrap', maxWidth: '280px'}}}>
											<A href={detailUrl} style={styles.productTitle}>
												{product.title}
											</A>
										</div>

										<div className="flexRow" style={{paddingLeft: '10px', marginTop: '5px', alignItems: 'center'}}>
											{profilePic}
											<A href={designerUrl} style={{paddingLeft: '10px', textDecoration: 'none', color: '#999', fontSize: '90%', 
															':hover': {color: 'black'}}}>
												Art by <span style={{textTransform: 'capitalize'}}>{createrName}</span>
											</A>
										</div>
										
										
									</div>
								}
							</div>	
						}
						
						{showProduct && 
							<div className={'flexColumn '+imageSizeClass} style={[styles.imgContainer]}>

								<A href={productUrl} style={{display: 'inline-flex'}}>
									<Img src={product.productImages[0]} alt={product.title+" "+productType} className={imageSizeClass} />
								</A>
								

								<div className='flexColumn productInfo' style={styles.productInfoContainer}>

									<A href={productUrl} style={styles.productTitle}>
										{product.title}
									</A>

									<div className='flexRow' style={styles.creatorContainer}>
										{profilePic}
										{product.creator &&
											<A href={designerUrl} style={{paddingLeft: '10px', textDecoration: 'none', color: '#999',
																		':hover': {color: 'black'}}}>
												
												<span>by <span style={{textTransform: 'capitalize'}}>{createrName}</span></span>
											</A>
											
										}

										<PriceLabel style={{textAlign: 'right', paddingRight:'10px', marginLeft: 'auto'}} 
													price={product.price} 
													aliasPrice={product.aliasPrice}
													productType={product.productType} />
									</div>
								</div>
							</div>
						}
					</div>

					{productTags && 
						<div style={styles.productTags}>
							{productTags}
						</div>
					}
				</div>
	}	
};

export default Radium(ProductDesignThumbnail);




// WEBPACK FOOTER //
// ./src/views/product/ProductDesignThumbnail.js